<template>
  <div class="pro-box">
    <div class="container productBox">
      <div class="productBox_calss">
        <div class="productList">
          <div :class="`productBox_tiems ${clNuStr == '' ? 'actives':''}`" @click="classChange({cl_Nu: ''})">
            <div :class="`circle ${clNuStr == '' ? 'grode':''} `"></div>
            <div class="contents">
              {{ $hs('全部','All','All') }}
              <!-- <span :class="clNuStr == '' ? 'spanActive':''">[{{allNum}}]</span> -->
            </div>
          </div>
          <div
            :class="`productBox_tiems ${clNuStr == item.cl_Nu ? 'actives':''}`"
            v-for="(item, index) in options"
            :key="index"
            :ref="'items'+index"
            @click="classChange(item)"
          >
            <div :class="`circle ${clNuStr == item.cl_Nu ? 'grode':''} `"></div>
            <div class="contents">
              {{ item[$hs('cl_Na','cl_Ne_Na','threeLanguage')] }}
              <span
                :class="clNuStr == item.cl_Nu ? 'spanActive':''"
              >[{{ item['count'] }}]</span>
            </div>
          </div>
        </div>
      </div>
      <div class="productBox_contents">
        <div class="product_nav">
          <span @click="$router.push('/home')">{{ $hs("首页","Home") }} ></span>
          <span style="margin-left: 5px;">{{ $hs("合作伙伴"," Cooperative Partner") }}</span>
        </div>
        <div class="productBox_imageList" v-if="logoList.length>0">
          <div class="images_wrapper" v-for="(item,index) in logoList" :key="index" :title="item.ma_Na">
            <img :src="item.ma_Logo" alt />
          </div>
        </div>
        <div class="product_nodata" v-else>
          <el-empty></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ProductClassWebGetProductCountByClass } from '@/api/home'
import { BrandRecommendationWebGetList } from '@/api/home'
export default {
  components: {
  },
  data() {
    return {
      productList: [],
      clNuStr: '',
      options: [],
      logoList: [],
    }
  },
  computed: {},

  created() {
    this.getMenusList()
    this.showList()
  },

  mounted() { },

  methods: {
    classChange(optiosn) {
      this.clNuStr = optiosn.cl_Nu
      this.$router.push({
        name: 'product',
        params: {
          clNu: optiosn.cl_Nu
        }
      })
    },
    showList() {
      this.logoList = []
      BrandRecommendationWebGetList({ num: 1000 }).then((res) => {
        if (res.success) {
          this.logoList = res.data
        }
      })

    },
    getMenusList() {
      ProductClassWebGetProductCountByClass().then(res => {
        if (res.success) {
          this.options = res.data
        }
      }).catch(err => {
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.productBox_imageList {
  display: flex;
  flex-wrap: wrap;
  .images_wrapper {
    width: 220px;
    height: 139px;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    margin-right: 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      max-width: 190px;
      max-height: 120px;
    }
  }
}

.pro-box {
  .productBox {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    .productBox_calss {
      // position: sticky;
      // top: 115px;
      width: 250px;
      max-height: 736px;
      border: 1px solid #e5e5e5;
      margin-bottom: 50px;
      .productBox_header,
      .productBox_tiems {
        height: 36px;
        line-height: 36px;
        font-size: 12px;
        font-weight: 500;
        text-align: left;
        color: #ffffff;
        display: flex;
        align-items: center;
        cursor: pointer;
        overflow: hidden;
        span {
          color: #ff0000;
        }
      }
      .productBox_tiems {
        background: #fff;
        color: #222222;
        .contents {
          width: 180px;
          white-space: nowrap; /* 禁止换行 */
          overflow: hidden;
          text-overflow: ellipsis; /* 显示省略号 */
        }
        &:hover {
          background: #ff0000;
          color: #fff;
          span {
            color: #fff;
          }
        }
      }
      .circle {
        width: 6px;
        height: 6px;
        background: #dfdfdf;
        border-radius: 50%;
        margin-left: 10px;
        margin-right: 15px;
      }
      .grode {
        background: #fff;
      }
      .productList {
        max-height: 736px;
        overflow: auto;
      }
      // 滚动条宽度
      .productList::-webkit-scrollbar {
        width: 7px;
      }
      // 滚动条轨道
      .productList::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
        border-radius: 2px;
      }
      // 小滑块
      .productList::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 10px;
      }
      .productList::-webkit-scrollbar-thumb:hover {
        background: #c1c1c1;
      }

      .actives {
        background: #ff0000;
        color: #fff;
      }
      .spanActive {
        color: #fff !important;
      }
    }
    .productBox_contents {
      width: 940px;
      margin-left: 22px;
      .product_nav {
        font-size: 16px;
        font-weight: 400;
        color: #222222;
        line-height: 26px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        span:hover {
          color: #ff0000;
          cursor: pointer;
        }
      }
      .product_nodata {
        text-align: center;
      }
    }
  }
  .search {
    width: 100%;
    // height: 412px;
    margin: 20px 0 0 0;
    box-shadow: 0 0 8px 1px #ebebeb;
    padding: 10px 20px;
    box-sizing: border-box;

    .active {
      display: flex;
      justify-content: space-between;
      .btn {
        color: #f2410f;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          color: #409eff;
        }
      }
    }

    .flex-box {
      display: flex;
      justify-content: space-between;
      .el-form-item {
        width: 46%;
        margin: 0 !important;

        :deep(.el-form-item__label) {
          padding: 0 !important;
          height: 36px;
          line-height: 36px;
        }

        :deep(.el-radio) {
          margin-right: 5px !important;
        }
      }
    }
    .form-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0 10px;
      & > div {
        width: 120px;
        height: 46px;
        line-height: 45px;
        border-radius: 6px;
        text-align: center;
        color: #fff;
        margin: 0 20px 0 0;
        font-size: 16px;
        cursor: pointer;
      }

      .search-btn {
        background: #f2410f;
      }

      .reset {
        background: #1f1f1f;
      }
    }
  }

  .pro-list {
    display: flex;
    flex-wrap: wrap;

    .cell {
      width: 220px;
      margin-right: 16px;
      margin-bottom: 20px;
      &:nth-child(4n) {
        margin-right: 0px;
      }
    }
  }

  .pagination {
    display: flex;
    justify-content: center;
    padding: 40px 0;
  }
}
</style>